import { FC } from 'react';

import { SinglePlaceholder } from './SinglePlaceholder';

export const SessionsPlaceholder: FC = () => {
  return (
    <>
      <SinglePlaceholder />
      <SinglePlaceholder />
      <SinglePlaceholder />
    </>
  );
};
